<script setup lang="ts">
  import { onMounted, PropType, ref, watch } from 'vue'

  import { Modal } from 'bootstrap'

  const MODAL_ID = 'modal-email-ownership-generic-error'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const props = defineProps({
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: true,
    },
  })

  onMounted(() => {
    modal.value = new Modal(`#${MODAL_ID}`, {
      backdrop: 'static',
      keyboard: false,
    })
  })

  watch(
    () => props.show,
    (newValue) => {
      if (newValue) {
        modal.value?.show()
        return
      }

      forceHide()
    },
  )

  function forceHide() {
    modal.value?.hide()
    document
      .querySelectorAll('.modal-backdrop')
      .forEach((backdrop) => backdrop.remove())
    document.getElementById(MODAL_ID)?.classList.remove('show')
    document.body.classList.remove('modal-open')
  }

  function close() {
    modal.value?.hide()
    setTimeout(() => {
      props.onClose()
    }, 300)
  }
</script>

<template>
  <div
    :id="MODAL_ID"
    class="modal modal-md fade"
    tabindex="-1"
    aria-labelledby="modalEmailOwnershipGenericErrorTitle"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <h5 id="modalEmailOwnershipGenericErrorTitle" class="modal-title">
            Ops, algo deu errado!
          </h5>

          <button class="btn-close" type="button" @click="close" />
        </div>

        <div class="modal-body py-3">
          <img
            alt="Ilustração de erro de comunicação"
            src="@/assets/images/worried-girl.svg"
            class="illustration"
          />
          <div class="mt-5">
            <p class="fs-6 text-start">{{ message }}</p>
          </div>
        </div>

        <div class="modal-footer py-3">
          <button class="btn btn-primary" type="button" @click="close">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    color: var(--bs-danger);
  }

  .illustration {
    display: block;
    height: 160px;
    margin: 0 auto;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }
</style>
